import { Badge, Button, Grid, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AMStatCards from "../ReusableComponents/AMStatCards";
import Title from "../ReusableComponents/title";
import AdvancedStaistics from "./AdvancedStaistics";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import TradesLots from "./TradesLots";
import "../../assets/css/accountmetrics.scss";
import * as ReactBootstrap from "react-bootstrap";
import { Calendar } from "react-calendar";
import moment from "moment";
import "react-calendar/dist/Calendar.css";
import { useSelector } from "react-redux";
import cross from "../../assets/icons/cross-close.svg";
import { dollarUS } from "../../utilities/formatters";

const AdvancedInsights = ({
  data,
  AdvStats,
  TradingHistory,
  TradeJournalNew,
}) => {
  const [show, setShow] = useState("AdvancedStaistics");
  const [activeTradeCard, setActiveTradeCard] = useState();

  const handleChange = (e) => {
    var select = e.currentTarget.getAttribute("value");
    setShow(select);
  };
  const [profileActive, setProfileActive] = useState(1);

  // TRADES BY DATE //
  const tradesData = useSelector((state) => state.dashboard.tradesData);
  console.log(tradesData, "dataaaaaa");

  const [selectedDate, setSelectedDate] = useState(
    moment(Date.now()).format("YYYY-MM-DD")
  );
  const [filteredTrades, setFilteredTrades] = useState([]);
  const [information, setInformation] = useState();
  const [activeDate, setActiveDate] = useState();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTradeDate, setSelectedTradeDate] = useState(null);
  const [selectedTrade, setSelectedTrade] = useState(null);

  const [totolTrades, setTotalTrades] = useState();
  const [profitLoss, setProfitLoass] = useState();
  const [volume, setVolume] = useState();
  const [winners, setWinners] = useState();
  const [losers, setLosers] = useState();
  const [commiss, setCommiss] = useState();

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTrade(null);
  };

  // useEffect(() => {
  //   const filterTradesByDate = () => {
  //     const formattedSelectedDate = moment(selectedDate, "YYYY-MM-DD");
  //     const filteredData = [];

  //     for (let i = -2; i <= 2; i++) {
  //       const currentDate = formattedSelectedDate
  //         .clone()
  //         .add(i, "days")
  //         .format("YYYY-MM-DD");
  //         console.log(tradesData[currentDate], "paramessssssster");
  //       if (tradesData[currentDate] !== undefined) {
  //         filteredData.push({ [currentDate]: tradesData[currentDate] });
  //       } else {
  //         filteredData.push({ [currentDate]: {} });
  //       }
  //     }

  //     selectedDate && setFilteredTrades(filteredData);
  //   };

  //   filterTradesByDate();
  // }, [selectedDate, tradesData]);

  useEffect(() => {
    const filterTradessByDate = () => {
      const currentDate = moment(selectedDate, "YYYY-MM-DD");
      const filteredData = [];

      for (let i = -2; i <= 2; i++) {
        const date = currentDate.clone().add(i, "days").format("YYYY-MM-DD");
        filteredData.push({ [date]: {} }); // Push empty data for each date
      }

      setFilteredTrades(filteredData);
    };

    filterTradessByDate();
  }, [selectedDate]);

  const handleDateChange = (date) => {
    setSelectedDate(moment(date).format("YYYY-MM-DD"));
    setActiveTradeCard();
  };

  console.log(TradingHistory, "tradingHistory");

  // Create an object to store the total profit for each date
  const tradingProfits = {};

  // Calculate total profit for each date
  TradingHistory?.forEach((trade) => {
    const tradeDate = new Date(trade.date).toDateString();
    if (!tradingProfits[tradeDate]) {
      tradingProfits[tradeDate] = 0;
    }
    tradingProfits[tradeDate] += trade.profit;
  });

  const tileContent = ({ date }) => {
    const currentDate = date.toDateString();
    // Check if the current date has a total profit recorded
    if (tradingProfits[currentDate] !== undefined) {
      // Determine the color based on the total profit

      // Return the highlighted date with the determined color
      return (
        <Tooltip
          title={
            tradingProfits[currentDate] > 0
              ? "Profit Day"
              : tradingProfits[currentDate] < 0
              ? "Loss Day"
              : "Trade Day"
          }
          style={{ marginLeft: "7px" }}
        >
          <Badge
            color={
              tradingProfits[currentDate] > 0
                ? "success"
                : tradingProfits[currentDate] < 0
                ? "error"
                : "info"
            }
            badgeContent=" "
            variant="dot"
          ></Badge>
        </Tooltip>
      );
    }
    return null;
  };

  const filterTradingData = () => {
    // Filter trading data based on the selected date
    const filteredData = TradingHistory?.filter((entry) => {
      const entryDate = moment(entry.date).format("YYYY-MM-DD");
      return entryDate === selectedDate;
    });

    return filteredData;
  };

  useEffect(() => {
    const filterDataAsPerActiveDate = TradingHistory?.filter(
      (item) => moment(item.date).format("YYYY-MM-DD") === activeDate
    );
    setInformation(filterDataAsPerActiveDate);
    console.log(filterDataAsPerActiveDate, "kdk");
  }, [activeDate]);

  const ExtraInforChart = () => {
    const totalVolumn = information?.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.volume;
    }, 0);

    const winLose = information?.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.profit;
    }, 0);

    const totalCommission = information?.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.commission;
    }, 0);

    return (
      <>
        {[
          {
            data: information?.length !== 0 ? information?.length : 0,
            text: "Total Trades",
          },
          { data: winLose ? winLose : 0, text: "Gross P&L" },
          {
            data: isNaN(parseFloat(totalVolumn).toFixed(2))
              ? 0
              : parseFloat(totalVolumn).toFixed(2),
            text: "Volume",
          },
          { data: winLose > 0 ? winLose : 0, text: "Winners" },
          { data: winLose < 0 ? winLose : 0, text: "Losers" },
          { data: totalCommission ? totalCommission : 0, text: "Commission" },
        ].map((item, index) => {
          return (
            <div key={index}>
              <p
                style={{
                  color:
                    item.text === "Winners"
                      ? "#0CCE6B"
                      : item.text === "Losers"
                      ? "#FD504F"
                      : "",
                }}
              >
                {item.text}
              </p>
              <span>
                {item.text === "Commission" || item.text === "Gross P&L"
                  ? dollarUS(item.data)
                  : isNaN(parseFloat(item.data).toFixed(2))
                  ? 0
                  : parseFloat(item.data).toFixed(2) || 0}
              </span>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div>
      <div
        className="d-flex"
        style={{ flexDirection: "column-reverse", width: "100%" }}
      >
        {isModalOpen && (
          <TradeModal
            date={selectedTradeDate}
            isOpen={isModalOpen}
            closeModal={closeModal}
            trade={selectedTrade}
          />
        )}
        <div className="tradesByDate">
          <div className="left">
            <Calendar onChange={handleDateChange} tileContent={tileContent} />
          </div>
          <div className="right">
            <div className="top">
              <p className="day_name">
                {selectedTradeDate === null
                  ? moment(Date.now()).format("dddd, YYYY")
                  : moment(selectedTradeDate).format("dddd, YYYY")}
              </p>
            </div>
            <div className="mid">
              <div className="tradeCards_wrapper">
                {filteredTrades.map((item, index) => {
                  return (
                    <TradeCard
                      key={index}
                      date={item}
                      setIsModalOpen={setIsModalOpen}
                      setSelectedTradeDate={setSelectedTradeDate}
                      setSelectedTrade={setSelectedTrade}
                      index={index}
                      activeTradeCard={activeTradeCard}
                      setActiveTradeCard={setActiveTradeCard}
                      TradingHistory={TradingHistory}
                      res={filteredTrades?.map((item) => item)}
                      dataa={TradeJournalNew}
                      setActiveDate={setActiveDate}
                      activeDate={activeDate}
                      selectedDate={selectedDate}
                    />
                  );
                })}
              </div>
              <div className="extra_information">
                <ExtraInforChart />
              </div>
            </div>
            <div className="bottom"></div>
          </div>
        </div>

        <div
          className="InsightsTabTable mbb-20"
          style={{ order: 3, width: "100%" }}
        >
          <div className="profileTabination">
            <div
              onClick={() => setProfileActive(1)}
              className={
                "profileTabination-item noFill" + (profileActive === 1 && " active ")
              }
            >
              {" "}
              <div className="svgCon">
                {profileActive === 1 ? (
                  <svg
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 11V12.8C1 13.92 1 14.48 1.218 14.908C1.40974 15.2843 1.71569 15.5903 2.092 15.782C2.519 16 3.079 16 4.197 16H19M1 11V1M1 11L4.853 7.79L4.857 7.787C5.554 7.206 5.903 6.915 6.282 6.797C6.72913 6.65719 7.21116 6.67878 7.644 6.858C8.011 7.011 8.332 7.332 8.976 7.976L8.982 7.982C9.636 8.636 9.963 8.964 10.336 9.115C10.7774 9.29489 11.2686 9.31121 11.721 9.161C12.104 9.033 12.454 8.727 13.154 8.115L19 3"
                      stroke="#04C4E6"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    
                    />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 11V12.8C1 13.92 1 14.48 1.218 14.908C1.40974 15.2843 1.71569 15.5903 2.092 15.782C2.519 16 3.079 16 4.197 16H19M1 11V1M1 11L4.853 7.79L4.857 7.787C5.554 7.206 5.903 6.915 6.282 6.797C6.72913 6.65719 7.21116 6.67878 7.644 6.858C8.011 7.011 8.332 7.332 8.976 7.976L8.982 7.982C9.636 8.636 9.963 8.964 10.336 9.115C10.7774 9.29489 11.2686 9.31121 11.721 9.161C12.104 9.033 12.454 8.727 13.154 8.115L19 3"
                      stroke="grey"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                )}
              </div>{" "}
              Advanced Statistics
            </div>
            <div
              onClick={() => setProfileActive(2)}
              className={
                "profileTabination-item " + (profileActive === 2 && " active ")
              }
            >
              {" "}
              <div className="svgCon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_220_7770)">
                    <path
                      d="M17.8224 0L15.1855 3.33341L12.7129 2.07167L12.1252 1.78594L11.7485 2.333L9.18169 6.23862L6.80396 4.42829L6.35644 4.09533L5.90892 4.42905L3.17784 6.49996L0.517586 5.83327L0.140886 7.30988L3.15449 8.0718L3.50783 8.16704L3.79036 7.95218L6.35644 6.00013L8.92252 7.95294L9.55839 8.42838L10.0059 7.7617L12.6428 3.76161L15.0673 4.97611L15.6097 5.23821L19 0.952402L17.8224 0ZM12.4304 9.85774L11.7952 10.6669L9.2284 13.9051L6.80396 12.0475L6.35644 11.7145L5.90892 12.0483L3.27202 14.0483L0.659225 12.7378L0 14.1192L3.0136 15.643L3.4129 15.8335L3.7896 15.5722L6.35644 13.6194L8.92252 15.5722L9.51092 16.0004L9.95844 15.4289L12.3128 12.4529L14.7614 16.1428L15.3505 17L15.9856 16.1908L18.9992 12.3812L17.8224 11.4288L15.4681 14.4049L13.0195 10.7149L12.4304 9.85774Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_220_7770">
                      <rect
                        width="19"
                        height="19"
                        fill="white"
                        transform="translate(0.5 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>{" "}
              Trades by Lots
            </div>
          </div>
          <div style={{ width: "100%" }}>
            {profileActive === 1 && (
              <>
                <AdvancedStaistics
                  data={data}
                  AdvStats={AdvStats && AdvStats}
                />
              </>
            )}
            {profileActive === 2 && (
              <TradesLots
                TradesLotsPerDay={
                  AdvStats &&
                  AdvStats["trades_and_lots_per_day "] &&
                  AdvStats["trades_and_lots_per_day "]
                }
                LotsPerTrade={
                  AdvStats && AdvStats.lots_per_trade && AdvStats.lots_per_trade
                }
                ConcurrentTrades={
                  AdvStats &&
                  AdvStats.concurrent_trades_lots &&
                  AdvStats.concurrent_trades_lots
                }
                RiskPerTrade={
                  AdvStats && AdvStats.risk_per_trade && AdvStats.risk_per_trade
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedInsights;

const TradeCard = ({
  date,
  setIsModalOpen,
  setSelectedTradeDate,
  setSelectedTrade,
  index,
  activeTradeCard,
  setActiveTradeCard,
  TradingHistory,
  selectedDate,
  dataa,
  activeDate,
  setActiveDate,
}) => {
  const key = Object.keys(date)[0].toString();

  const data = date[key];

  // let dates = [...data];

  const day = key.slice(-2);

  const d = moment(key).format("YYYY-MM-DD");

  const resultTwo = TradingHistory?.map((item) => item).filter(
    (item) => moment(item.date).format("YYYY-MM-DD") === d && item.length !== 0
  );

  // FORMATE FOR PRICE INTO "K"
  const formatPrice = (price) => {
    if (Math.abs(price) >= 1000) {
      return (
        (price < 0 ? "-$" : "$") + (Math.abs(price) / 1000).toFixed(2) + "K"
      );
    } else {
      return (price < 0 ? "-$" : "$") + Math.abs(price).toFixed(2);
    }
  };

  const sumOfTrades = resultTwo?.reduce((accumulator, currentValue) => {
    return accumulator + currentValue.profit;
  }, 0);

  const fomattedTotalTrades = formatPrice(sumOfTrades);
  const sumOfVolume = resultTwo?.reduce((accumulator, currentValue) => {
    return accumulator + currentValue.volume;
  }, 0);

  // useEffect(() => {
  //   setVolume(sumOfVolume);
  // }, [sumOfVolume]);

  return (
    date && (
      <div
        className={
          index === activeTradeCard
            ? "tradeCard active_trade_card"
            : "tradeCard"
        }
        onClick={() => {
          setSelectedTradeDate(key.toString());
          setSelectedTrade(typeof data === "object" ? data : null);
          setActiveDate(key);
          data?.trades && setIsModalOpen(true);
          setActiveTradeCard(index);
        }}
      >
        <div className="top">
          <div className="left">{data.trades && data.trades[0].symbol}</div>
          <div
            className={`right ${parseFloat(data.profitSum) < 0 ? "loss" : ""}`}
          >
            <p>
              <span>{day}</span>
            </p>
          </div>
        </div>
        <div
          className="mid"
          style={{ width: "100%", display: "flex", justifyContent: "end" }}
        >
          <span>{moment(key).format("dddd")}</span>
        </div>
        <div
          className={`bottom ${
            (parseFloat(data.profitSum) < 0 && "loss") ||
            (parseFloat(data.profitSum) > 0 && "profit")
          }`}
        >
          <p
            className={`trade_cart_profit_loss ${
              sumOfTrades >= 1 &&
              activeTradeCard === index &&
              "profit_tradeCard"
            } ${
              sumOfTrades < 0 && activeTradeCard === index && "loss_tradeCard"
            }`}
          >
            {isNaN(sumOfTrades) ? "0$" : fomattedTotalTrades}
          </p>
        </div>
      </div>
    )
  );
};

const TradeModal = ({ isOpen, closeModal, trade, date }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, closeModal]);

  console.log(trade);
  // const tradeKeys = Object?.keys(trade?.trades[0]);
  // console.log(tradeKeys);
  const formatDate = (dateString) => {
    const options = { hour: "numeric", minute: "numeric", second: "numeric" };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };
  const dates = Object.keys(date);
  const extractedDate = dates.length > 0 ? dates[0] : null;

  const formattedDate = extractedDate
    ? new Date(extractedDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null;

  console.log(formattedDate);

  return (
    <div className={`trade-modal ${isOpen ? "open" : ""}`}>
      <div className="modal_content" ref={modalRef}>
        <div className="modal_header">
          <p>{moment(date).format("ll")}</p>
          <button className="close-button" onClick={closeModal}>
            <img src={cross} alt="" />
          </button>
        </div>
        {trade && (
          <div style={{ marginTop: "20px" }}>
            <div className="PageContainer LeaderboardPage PaymentHistoryPage mtt-20">
              <div className="HistoryDesk">
                <ReactBootstrap.Table className="LeaderboardTable">
                  <thead>
                    <tr style={{ textWrap: "nowrap" }}>
                      <th>Action</th>
                      <th>Commission Sum</th>
                      <th>Date Close</th>
                      <th>Date Open</th>
                      <th>Login</th>
                      <th>Position</th>
                      <th>Price Avg Buy</th>
                      <th>Price Avg Sell</th>
                      <th>Profit Sum</th>
                      <th>Stop Loss</th>
                      <th>Swap Sum</th>
                      <th>Symbol</th>
                      <th>Take Profit</th>
                      <th>Volume Sum Buy</th>
                      <th>Volume Sum Sell</th>
                    </tr>
                  </thead>
                  <tbody>
                    {trade?.trades?.map((trade, index) => (
                      <tr key={index}>
                        <td>{trade?.action}</td>
                        <td>{trade?.commissionSum}</td>
                        <td>{formatDate(trade.dateClose)}</td>
                        <td>{formatDate(trade.dateOpen)}</td>
                        <td>{trade?.login}</td>
                        <td>{trade?.position}</td>
                        <td>{trade?.priceAvgBuy}</td>
                        <td>{trade?.priceAvgSell}</td>
                        <td
                          className={`${trade.profitSum > 0 ? "green" : "red"}`}
                        >
                          {trade.profitSum}
                        </td>
                        <td>{trade?.stopLoss}</td>
                        <td>{trade?.swapSum}</td>
                        <td>{trade?.symbol}</td>
                        <td>{trade?.takeProfit}</td>
                        <td>{trade?.volumeSumBuy}</td>
                        <td>{trade?.volumeSumSell}</td>
                      </tr>
                    ))}
                  </tbody>
                </ReactBootstrap.Table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
